<template>    
    <div class="footer">
        <div class="center">copyright &copy; {{currentYear}} UtterAccess, Inc.</div>
        <div class="center">software by <a href="https://www.dymeng.com" target="_blank">Dymeng</a>, design by <a href="https://designextensions.com/" target="_blank">Design Extensions</a><router-link :to="{path: '/guidelines'}"> - Privacy Policy</router-link></div>
    </div>    
</template>

<script>

    

    export default {                
        computed: {            
            currentYear() {
                return new Date().getFullYear();
            }
        }
    }
</script>

